import { UnitOfMeasureEntity } from "@ots-frontend/ots-data";
import { useCallback } from "react";
import { BaseEntitySelect, BaseEntitySelectProps } from "../base-entity-select";

export type BaseUnitOfMeasureSelectProps = Omit<
  BaseEntitySelectProps<UnitOfMeasureEntity>,
  'nameMapper' | 'valueMapper'
> & {
  useAbbreviation?: boolean;
};

export const BaseUnitOfMeasureSelect = (
  props: BaseUnitOfMeasureSelectProps
) => {
  const { useAbbreviation = true, ...rest } = props;

  const valueMapper = useCallback((uom: UnitOfMeasureEntity) => {
    return uom.name;
  }, []);

  const nameMapper = useCallback(
    (uom: UnitOfMeasureEntity) => {
      if (useAbbreviation) {
        return uom.abbr ?? uom.name;
      } else {
        return uom.name;
      }
    },
    [useAbbreviation]
  );

  return (
    <BaseEntitySelect
      valueMapper={valueMapper}
      nameMapper={nameMapper}
      {...rest}
    />
  );
};
